export default __webpack_public_path__ + "static/media/ic_add_square_white.60e70ca2.svg";